import React, { useState, useEffect } from 'react';
import '../css/homepage_org.css';
import { useNavigate } from 'react-router-dom';
import { API_URL_BASE } from '../config';

const AuthForm = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [NameError, setNameError] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState('');
  const navigate = useNavigate();	
	
  const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  const validatePassword = (val) => val.length >= 6;
  const validateName = (val) => val.length >= 1;

  useEffect(() => {
    setEmailError('');
    setPasswordError('');
    setNameError('');

    if (email && !validateEmail(email)) setEmailError('Invalid email');
    if (password && !validatePassword(password)) setPasswordError('Min 6 characters');
    if (!isLogin && name && !validateName(name)){
		setNameError('Full name is required');
	} 

    const isValid =
      validateEmail(email) &&
      validatePassword(password) &&
	  (!isLogin ? validateName(name) : true);
	  
	  setIsFormValid(isValid);
  }, [email, password, name, isLogin]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    //alert(`${isLogin ? 'Logging in' : 'Signing up'} as ${email}`);
    // You can call your backend API here
	if (isLogin){ //Handle LOGIN
			try{
			  	const response = await fetch(API_URL_BASE + '/ticket.json', {
			    	method: 'POST',
			    	headers: {
			      	'Content-Type': 'application/json',
			    	},
			    	body: JSON.stringify(					{
						login : {
							user  : {	
								email: email,
								password: password
							}}
					  })
			  	});
			  
				  // Check if fetch succeeded (status not blocked)
				  if (!response.ok) {
				    throw new Error(`Server error: ${response.status}`);
				  }
			  
				  const jsonresponse = await response.json(); // Parse JSON response
				  const result = jsonresponse.message.includes(',') ? jsonresponse.message.split(",")[0] : jsonresponse.message;
	
				  
				  // Handle response message and navigate accordingly
				  switch (result) {
				    case "USER_NOT_EXISTS":
				      setError("User does not exist. Please sign up!!");
				      break;

				    case "LOGIN_SUCCESS":
					  localStorage.setItem("userName", jsonresponse.message.split(",")[1]); 
					  localStorage.setItem("userId", jsonresponse.message.split(",")[2]);
					  localStorage.setItem("token", jsonresponse.message.split(",")[3]);
					  localStorage.setItem("role", jsonresponse.message.split(",")[4] || "ORGANISER");
				      navigate('/dashboard'); // Redirect to dashboard
				      break;

					case "ACCOUNT_INACTIVE":
					  	setError("");
					  	setMessage("Account is inactive. Please contact the administrator contact@buydeal.eu!"); // Show success message
					  	setIsLogin(true); //  Switch to login mode
					  	setEmail(""); 
					  	setPassword("");
					  	setName("");
					  	break;						  					  

				    case "INVALID_CREDENTIALS":
				      setError("Invalid email or password.");
				      break;

				    default:
				      setError("An unexpected error occurred.");
				  }
			}
			catch(err){
				setError(err.message || " An unexpected error occurred with Login!!");
				//setError(err.response);
			}
		} 
		else { // Handle SIGNUP
			try {
				setError("");
				setMessage("");
			
			const response = await fetch(API_URL_BASE + '/ticket.json', {
						    	method: 'POST',
						    	headers: {
						      	'Content-Type': 'application/json',
						    	},
						    	body: JSON.stringify(					{
									signup : {
										user  : {	
											email: email,
											password: password,
											name:name
										}}
								  })
						  	});
							

			// Check if fetch succeeded (status not blocked)
			if (!response.ok) {
			  throw new Error(`Server error: ${response.status}`);
			}

			const result = await response.json();
			console.log(result);
			console.log(result.message);

			// Handle response message and navigate accordingly
			switch (result.message) {
			  case "USER_EXISTS":
				setMessage("");
			    setError("User already exists!!");
			    break;

			  case "SIGNUP_SUCCESS":
				setError("");
				setMessage("Successfully registered. Please wait to activate your account by the administrator!"); // Show success message
				setIsLogin(true); //  Switch to login mode
				setEmail(""); 
				setPassword("");
				setName("");
			    break;			

			  default:
				setMessage("");
			    setError("An unexpected error occurred.");
			}
			} catch (err) {
			  setError(err.message || " An unexpected error occurred with Signup!!");
			}
		}
	
  };

  return (
    <div className="login-box-container">
      <h2>{isLogin ? 'Login' : 'Sign Up'}</h2>
	  <p className="error-text">{message}{error}</p>
      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            value={email}
            className={emailError ? 'input-error' : ''}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter email"
          />
          {emailError && <p className="error-text">{emailError}</p>}
        </div>

        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            className={passwordError ? 'input-error' : ''}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
          />
          {passwordError && <p className="error-text">{passwordError}</p>}
        </div>

        {!isLogin && (
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              value={name}
              className={NameError ? 'input-error' : ''}
              onChange={(e) => setName(e.target.value)}
              placeholder="Full Name"
            />
            {NameError && <p className="error-text">{NameError}</p>}
          </div>
        )}

        <button className="login-btn"
		type="submit" disabled={!isFormValid}>
          {isLogin ? 'Login' : 'Sign Up'}
        </button>

        <p className="switch-text">
          {isLogin ? "Don't have an account?" : 'Already have an account?'}{' '}
          <span onClick={() => {setIsLogin(!isLogin); setError(""); setMessage(""); }}>
            {isLogin ? 'Sign Up' : 'Login'}
          </span>
        </p>
      </form>
    </div>
  );
};

export default AuthForm;
